module.exports = __webpack_public_path__ + "front/img/edm-banner-xianxia.028994f9.png";